/**
 * OA办公杂项模块（src/views/OAoffice：投诉/报修/营业网点/停水信息）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 * 术语约定：投诉=Complaint，报修=Repair Report，营业网点/营业厅=Business Outlet/Business Hall，
 *          停水=Water Outage，回访=Follow-up Visit，满意度=Satisfaction，处理人=Handler
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',
  '状态': 'Status',
  '备注': 'Remark',
  '创建时间': 'Created At',
  '确定删除吗?': 'Are you sure you want to delete?',
  '已选择 {count} 项': '{count} items selected',
  '下载': 'Download',
  '上传': 'Upload',
  '无图片': 'No Image',
  '无文件': 'No File',
  '图片': 'Images',

  // ── 投诉管理（complaintManagement）──
  '联系人名称': 'Contact Name',
  '联系人电话': 'Contact Phone',
  '精确地址': 'Exact Address',
  '情况描述': 'Situation Description',
  '留言信息': 'Message Information',
  '留言类型': 'Message Type',
  '留言描述': 'Message Description',
  '请选择状态': 'Select status',
  '请选择留言类型': 'Please select the message type',
  '未处理': 'Unprocessed',
  '已处理': 'Processed',
  '咨询': 'Inquiry',
  '建议': 'Suggestion',
  '投诉': 'Complaint',
  '处理中': 'Processing',
  '等待评价': 'Awaiting Evaluation',
  '结束': 'Finished',
  '处理': 'Handle',
  '处理人': 'Handler',
  '处理时间': 'Handling Time',
  '处理人姓名': 'Handler Name',
  '处理人联系方式': 'Handler Contact Information',
  '是否已解决': 'Resolved or Not',
  '已解决': 'Resolved',
  '未解决': 'Unresolved',
  '处理信息': 'Handling Info',
  '处理描述': 'Handling Description',
  '查看评价': 'View Evaluation',
  '评价': 'Evaluation',
  '评分等级': 'Rating Level',
  '评分描述': 'Rating Description',
  '用户名称': 'Customer Name',
  '用户联系电话': 'Customer Contact Phone',
  '用户地址': 'Customer Address',
  '请输入联系人名称': 'Please enter the contact name',
  '请输入处理人姓名': 'Please enter handler name',
  '请输入处理人联系方式': 'Please enter handler contact information',
  '请输入处理描述': 'Please enter handling description',
  '请输入备注信息': 'Please enter remark',
  '请选择是否解决': 'Please select whether resolved',
  '请输入正确的手机号码': 'Please enter a valid mobile phone number',

  // ── 故障报修（faultRepairReport）──
  '工单信息': 'Work Order Information',
  '工单编号': 'Work Order No.',
  '工单类型': 'Work Order Type',
  '工单联系人': 'Work Order Contact',
  '联系电话': 'Contact Phone',
  '报修信息': 'Repair Report Info',
  '报修状态': 'Repair Report Status',
  '报修人名称': 'Reporter Name',
  '报修人电话': 'Reporter Phone',
  '报修户地址': 'Reporter Address',
  '报修地址': 'Repair Address',
  '报修描述': 'Repair Description',
  '报修时间': 'Report Time',
  '报修图片:': 'Repair Photos:',
  '草稿': 'Draft',
  '审批中': 'Under Approval',
  '处理结束': 'Processing Completed',
  '请输入工单编号': 'Please enter work order no.',
  '请输入报修人名称': 'Please enter reporter name',
  '请选择报修状态': 'Please select repair report status',
  '是否开启工单': 'Create Work Order or Not',
  '回复内容': 'Reply Content',
  '请选择是否开启工单': 'Please select whether to create a work order',
  '请输入回复内容': 'Please enter reply content',
  '请选择工单类型': 'Please select work order type',
  '换表': 'Meter Replacement',
  '工程报装': 'Engineering Installation',
  '故障报修': 'Fault Repair',
  '请输入工单联系人': 'Please enter work order contact',
  '请输入联系电话': 'Please enter contact phone',
  '紧急程度': 'Urgency',
  '请选择工单紧急程度': 'Please select work order urgency',
  '正常': 'Normal',
  '紧急': 'Urgent',
  '地理信息': 'Geographic Info',
  '请输入工单位置': 'Please enter work order location',
  '截止时间': 'Deadline',
  '预约时间': 'Appointment Time',
  '请选择紧急程度': 'Please select urgency',
  '处理成功！': 'Handled successfully!',

  // ── 营业网点（businessOutlets）──
  '营业厅名称': 'Business Hall Name',
  '营业厅电话': 'Business Hall Phone',
  '营业厅工作日': 'Business Hall Working Days',
  '营业厅工作时间': 'Business Hall Working Hours',
  '营业厅经度': 'Business Hall Longitude',
  '营业厅纬度': 'Business Hall Latitude',
  '营业厅地址': 'Business Hall Address',
  '请输入营业厅名称': 'Please enter the business hall name',
  '请输入营业厅电话': 'Please enter the business hall phone',
  '请输入营业厅工作日': 'Please enter business hall working days',
  '请输入营业厅工作时间': 'Please enter business hall working hours',
  '请输入营业厅经度': 'Please enter business hall longitude',
  '请输入营业厅纬度': 'Please enter business hall latitude',
  '请输入营业厅地址': 'Please enter business hall address',
  '请输入正确的座机号码': 'Please enter a valid landline number',

  // ── 停水信息（waterOutageInformation）──
  '停水范围': 'Water Outage Area',
  '停水时间': 'Water Outage Time',
  '停水原因': 'Water Outage Cause',
  '停水开始时间': 'Water Outage Start Time',
  '停水结束时间': 'Water Outage End Time',
  '影响范围': 'Affected Area',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '请输入停水范围': 'Please enter water outage range',
  '请选择停水开始时间': 'Please select the water outage start time',
  '请选择停水结束时间': 'Please select the water outage end time',
  '请输入影响范围': 'Please enter affected area',
  '请输入停水原因': 'Please enter water outage cause',
}
